export function cn(...cls: (string | undefined | null | false | 0)[]): string {
  return cls.filter(Boolean).join(' ');
}
